import { useResetRecoilState, useSetRecoilState } from 'recoil';

import {
  fixedIncomeOffersByFilterParamsState,
  fixedIncomeOffersBySearchTermParamsState,
  fundOffersByFilterParamsState,
  fundOffersBySearchTermParamsState,
  productItemState,
  productStatusState,
  equityOffersBySearchTermParamsState,
  equityOffersParamsState,
  structuredOperationsOffersParamsState,
  structuredOperationsOffersBySearchTermParamsState,
} from '../atom';
import { changeProductStatus, productItem } from '../selectors';
import { ProductStatus, SelectedProduct } from '../types';

export const useProductActions = () => {
  const setProductItem = useSetRecoilState(productItem);
  const setProductStatus = useSetRecoilState(changeProductStatus);

  const clearProductItem = useResetRecoilState(productItemState);
  const resetProductStatus = useResetRecoilState(productStatusState);

  const resetFixedIncomeOffersByFilterParams = useResetRecoilState(
    fixedIncomeOffersByFilterParamsState
  );
  const resetFundOffersByFilterParamsState = useResetRecoilState(fundOffersByFilterParamsState);
  const resetFundOffersBySearchTermParamsState = useResetRecoilState(
    fundOffersBySearchTermParamsState
  );
  const resetFixedIncomeOffersBySearchTermParamsState = useResetRecoilState(
    fixedIncomeOffersBySearchTermParamsState
  );
  const resetEquityOffersParams = useResetRecoilState(equityOffersParamsState);
  const resetEquityOffersBySearchTermParamsState = useResetRecoilState(
    equityOffersBySearchTermParamsState
  );
  const resetStructuredOperationsOffersParams = useResetRecoilState(
    structuredOperationsOffersParamsState
  );
  const resetStructuredOperationsOffersBySearchTermParamsState = useResetRecoilState(
    structuredOperationsOffersBySearchTermParamsState
  );

  const updateProductStatus = (data: ProductStatus) => {
    setProductStatus(data);
  };

  const handleSelectProductItem = (item: SelectedProduct) => {
    setProductItem(item);
  };

  const resetProduct = () => {
    clearProductItem();
    resetProductStatus();
  };

  const unselectProduct = () => {
    resetProduct();
    setProductStatus({ status: 'opened' } as ProductStatus);
  };

  const resetProductFilterAndSearchParams = () => {
    resetFixedIncomeOffersByFilterParams();
    resetFundOffersByFilterParamsState();
    resetEquityOffersParams();
    resetStructuredOperationsOffersParams();
    resetFundOffersBySearchTermParamsState();
    resetFixedIncomeOffersBySearchTermParamsState();
    resetEquityOffersBySearchTermParamsState();
    resetStructuredOperationsOffersBySearchTermParamsState();
  };

  return {
    updateProductStatus,
    handleSelectProductItem,
    resetProduct,
    unselectProduct,
    resetProductFilterAndSearchParams,
  };
};

export * from './fixedIncome';
export * from './funds';
export * from './equity';
export * from './directTreasury';
export * from './structuredOperations';
